import React from "react";
import AccountsBalance from "../components/AccountsBalance";
import OpenOrders from "../components/openorder";
import { Grid } from "@mui/material";

const Dashboard = () => {
    return (
        <div>
            <Grid container spacing={2}>
                <Grid item xs="auto">
                    <OpenOrders />
                </Grid>
                <Grid item xs="auto">
                    <AccountsBalance />
                </Grid>
            </Grid>
        </div>
    );
};

export default Dashboard;
